/*
 * /patient/$patientId (page)
 */
import { Card, CardContent, CardHeader, CardTitle, Container, Page, Placeholder } from "@emr/react-ui"
import { createFileRoute } from "@tanstack/react-router"
import { trpc } from "../../trpc"
import { GeneralNoteList } from "../../features/generalnote/general-note-list"
import { PatientHeader } from "../../features/patient/patient-header"
import type { Patient } from "@emr/db/client"

export const Route = createFileRoute("/patient/$patientId")({
	component: PatientPage,
})

/* ─── Mock patient (used when DB returns nothing) ────────────────────────── */

const MOCK_PATIENT: Partial<Patient> = {
	firstName: "John",
	lastName: "Doe",
	dateOfBirth: new Date("1978-08-19") as any,
	bloodType: "O+",
	allergies: "Penicillin",
	emergencyContactName: "Jane Doe (Spouse)",
	emergencyContactPhone: "(506) 897-6116",
}

/* ─── Page ───────────────────────────────────────────────────────────────── */

function PatientPage() {
	const { patientId } = Route.useParams()

	const { data: patient, isLoading: patientLoading } =
		trpc.patient.getByFilter.useQuery({ where: { id: patientId } })

	const { data: notesData, isLoading: notesLoading } =
		trpc.generalNote.getAllByFilter.useQuery({
			where: { patientId, active: true },
		})
	const notes = notesData ?? []

	const displayPatient = patient ?? (MOCK_PATIENT as Patient)
	const isLoading = patientLoading || notesLoading

	return (
		<Page centerVertical={false}>
			<PatientHeader patient={displayPatient} patientId={patientId} isDirty={false} />
			<Container width="xl" padding="lg" gap="lg">
				{isLoading ? (
					<Placeholder title="Loading..." />
				) : (
					<Card>
						<CardHeader>
							<CardTitle>Patient Notes</CardTitle>
						</CardHeader>
						<CardContent>
							<GeneralNoteList patientId={patientId} notes={notes} />
						</CardContent>
					</Card>
				)}
			</Container>
		</Page>
	)
}
